import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { toNum } from '@shared/helpers/math.helper';
import { DatiIdentificativiConstants } from '../../../../features/dati-identificativi/consts/dati-identificativi.constants';
import { getDatiIdentificativiControl, getDatiIdentificativiGroup } from './helpers/dati-identificativi-form-validators.helper';

export const datiIdentificativiMutualitaAlboRules: FormGroupRules = {
    my_CkMutualPrev: (form: FormGroup) => {
        const my_CkMutualPrevControl = getDatiIdentificativiControl(form, 'my_CkMutualPrev');
        const errors = my_CkMutualPrevControl.errors ? my_CkMutualPrevControl.errors : {};

        addRemoveError(my_CkMutualPrevControl?.value === '4', errors, 'my_CkMutualPrev', {
            status: "Attenzione: non è più possibile indicare la 'Mutualità prevalente di diritto'",
            message: "Non è più possibile indicare la 'Mutualità prevalente di diritto'",
        });

        addRemoveError(isNilOrEmpty(my_CkMutualPrevControl?.value), errors, 'my_CkMutualPrev', {
            status: DatiIdentificativiConstants.ERROR_MUTUAL_PREV_REQUIRED,
        });

        my_CkMutualPrevControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SezEnte: (form: FormGroup) => {
        const datiIdentificativiGroup = getDatiIdentificativiGroup(form);
        const my_SezEnteControl = getControl(datiIdentificativiGroup, 'my_SezEnte');
        const my_CkMutualPrev = toNum(getControl(datiIdentificativiGroup, 'my_CkMutualPrev')?.value);
        const tipoSezEnte: string = getControl(datiIdentificativiGroup, 'my_TipoSezEnte')?.value;
        const errors = my_SezEnteControl.errors ? my_SezEnteControl.errors : {};
        const showError = isNilOrEmpty(my_SezEnteControl?.value) && my_CkMutualPrev !== 3;

        addRemoveError(showError, errors, 'my_SezEnte', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(tipoSezEnte === '16', errors, 'my_SezEnte_sms', {
            status: 'Modello non utilizzabile per Società di Mutuo Soccorso',
            message: 'Questo modello non può essere utilizzato per le Società di Mutuo Soccorso',
        });

        my_SezEnteControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkImpresaSociale: (form: FormGroup) => {
        const datiIdentificativiGroup = getDatiIdentificativiGroup(form);
        const my_CkImpresaSocialeControl = getControl(datiIdentificativiGroup, 'my_CkImpresaSociale');
        const tipoSezEnte: string = getControl(datiIdentificativiGroup, 'my_TipoSezEnte')?.value;
        const showInconsistentResponseError = my_CkImpresaSocialeControl?.value != '1' && tipoSezEnte === '2';
        const errors = my_CkImpresaSocialeControl.errors ? my_CkImpresaSocialeControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkImpresaSocialeControl?.value), errors, 'my_CkImpresaSociale', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(showInconsistentResponseError, errors, 'my_CkImpresaSociale', {
            status: 'Risposta incoerente',
            message: "L'ente è impresa sociale",
        });

        my_CkImpresaSocialeControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_PosizAlboEnti: (form: FormGroup) => {
        const my_PosizAlboEntiControl = getDatiIdentificativiControl(form, 'my_PosizAlboEnti');
        const my_ValidaPosizAlboEnti: string = getControl(form, 'my_ValidaPosizAlboEnti')?.value;
        const errors = my_PosizAlboEntiControl.errors ?? {};
        const value: string = my_PosizAlboEntiControl.value;

        addRemoveError(isNilOrEmpty(value), errors, 'my_PosizAlboEnti', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(!isNilOrEmpty(value) && my_ValidaPosizAlboEnti === '0', errors, 'my_PosizAlboEnti', {
            status: 'Attenzione: valore non corretto',
            message:
                "Il numero di posizione albo deve obbligatoriamente essere una lettera e sei cifre (senza spazi o altri caratteri intermedi); al limite sono ammesse le diciture 'In attesa' o 'Non iscritta'.",
        });

        addRemoveError(value === 'A000000', errors, 'my_PosizAlboEnti', {
            status: 'Numero non consentito: utilizzare la dicitura "In Attesa"',
        });

        addRemoveError(value === 'A999999', errors, 'my_PosizAlboEnti', {
            status: 'Numero non consentito: utilizzare la dicitura "In Attesa"',
        });

        my_PosizAlboEntiControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
